import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

class EncryptionService {
    encrypt(value) {
        return Promise.resolve(value);
    }
    decrypt(value) {
        return Promise.resolve(value);
    }
    isEncryptionAvailable() {
        return Promise.resolve(false);
    }
    getKeyStorageProvider() {
        return Promise.resolve("basic_text" );
    }
    setUsePlainTextEncryption() {
        return Promise.resolve(undefined);
    }
}

export { EncryptionService };
